import ModelsTable from './ModelsTable'
import modelsTableContainer from './modelsTableContainer'

export default modelsTableContainer(ModelsTable)
